var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.5C11.3 13.3 17 11 19.5 10.5H21.5C26.7 10.9 30.3333 16.6667 31.5 19.5C32.6667 19.5 35.1 20.1 35.5 22.5C35.9 24.9 33 25.8333 31.5 26C28 34.5 18.5 34 15 33C12.2 32.2 9.16667 27.6667 8 25.5C6.83333 25.3333 4.5 24.4 4.5 22C4.5 19.6 7.16667 18.6667 8.5 18.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3065 33.0403C11.879 33.0403 8.86347 27.7422 8.32726 25.6613H7.94355C6.0496 25.6613 4.5 24.1117 4.5 22.2177C4.5 20.3238 6.0496 18.7742 7.94355 18.7742H8.43548",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33C27.9274 33 31.1285 27.9249 31.6647 25.9157H32.0484C33.9423 25.9157 35.4919 24.4196 35.4919 22.5909C35.4919 20.7623 33.9423 19.2661 32.0484 19.2661H31.5565",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7177 10.4113C26.9542 12.0479 30.8474 16.2028 31.5564 21.2339",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8145 22.2178C16.0862 22.2178 16.3064 21.9975 16.3064 21.7258C16.3064 21.4541 16.0862 21.2339 15.8145 21.2339C15.5428 21.2339 15.3226 21.4541 15.3226 21.7258C15.3226 21.9975 15.5428 22.2178 15.8145 22.2178Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6855 22.2178C23.9572 22.2178 24.1774 21.9975 24.1774 21.7258C24.1774 21.4541 23.9572 21.2339 23.6855 21.2339C23.4138 21.2339 23.1935 21.4541 23.1935 21.7258C23.1935 21.9975 23.4138 22.2178 23.6855 22.2178Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7661 8.25169C17.9151 7.83847 17.5067 6.6529 18.4611 5.61C18.8055 5.23613 19.2925 5 19.8041 5C21.1077 5 22.1408 6.05766 22.1654 7.36129C22.19 8.66984 21.2946 9.57008 20.419 10.1998C19.8041 10.6425 19.0908 10.9131 18.343 11.0016C12.9711 11.6411 8.70602 15.8718 8.03699 21.2339",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8145 32.3762C14.6733 31.9679 13.8468 30.8709 13.8468 29.5968C13.8468 27.9734 15.175 26.6451 16.7984 26.6451L17.2412 26.7189C18.899 26.9944 20.5962 26.9944 22.254 26.7189L22.6967 26.6451C24.3201 26.6451 25.6483 27.9734 25.6483 29.5968C25.6483 31.0529 24.5808 32.2729 23.1887 32.509",
    fill: "#F5FBFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8145 32.3762C14.6733 31.9679 13.8468 30.8709 13.8468 29.5968C13.8468 27.9734 15.175 26.6451 16.7984 26.6451L17.2412 26.7189C18.899 26.9944 20.5962 26.9944 22.254 26.7189L22.6967 26.6451C24.3201 26.6451 25.6483 27.9734 25.6483 29.5968C25.6483 31.0529 24.5808 32.2729 23.1887 32.509",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2258 30.315C22.3129 30.6643 23.1935 31.412 23.1935 32.5484C23.1935 34.1767 21.7177 35.5 19.7499 35.5C17.7822 35.5 16.3064 34.1767 16.3064 32.5484C16.3064 31.412 17.187 30.6643 18.2741 30.315",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 32.0565C20.565 32.0565 21.2258 31.3957 21.2258 30.5807C21.2258 29.7656 20.565 29.1049 19.75 29.1049C18.9349 29.1049 18.2742 29.7656 18.2742 30.5807C18.2742 31.3957 18.9349 32.0565 19.75 32.0565Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNio);
export default __webpack_public_path__ + "static/media/Ic_niño.f93fb8c5e5509931e5a0f360117cd713.svg";
export { ForwardRef as ReactComponent };